module.exports = __webpack_public_path__ + "media/images/select2-spinner-56d4c7ce2d3591a021073d07a6ea7342.gif";